// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-currency[data-v-7753335a]{white-space:nowrap}.v-currency>span[data-v-7753335a],.v-currency i[data-v-7753335a]{line-height:inherit;font-size:inherit;vertical-align:inherit;font-weight:inherit}i[data-v-7753335a]{font-style:normal}p[data-v-7753335a]{display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
